<template>
    <div class="culturalTourDetail">
        <div class="container">
            <div class="title">
                <h1>{{ detail.title }}</h1>
            </div>
            <div class="introduction" v-html="detail.content"></div>
               
            <div class="imgs">
                <img v-for="img in detail.imgs"
                     :key="img"
                     :src="img"
                     alt="">
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { articleDetail } from '@/api/index';
import { useRoute } from 'vue-router/composables';
const route = useRoute();
const id = route.query.id;
const detail = ref({});
onMounted(() => {
    // 获取详情
    articleDetail({ id: id }).then(({ data }) => {
        if (data) {
            detail.value = data;
        }

    });

});
</script>

<style lang="scss" scoped>
.culturalTourDetail{
    padding: 44px 0 200px;
    display: flex;
    justify-content: center;
    .container{
        width: 1420px;
        margin: auto;
    }
    .title{
        text-align: center;
        margin-bottom: 40px;
        h1{
            font-size: 40px;
            color: #333333;
            text-align: center;
            
        }
        p{
            font-size: 20px;
            color: #333333;
            text-align: center;
            margin: 20px 0;
        }
    }
    .introduction{
        p{
            font-size: 20px;
            color: #333333;
            text-indent: 2em;
            margin-bottom: 20px;
        }
    }
    .imgs{
        width: 100%;
        img{
            width: 100%;
        }
    }
}
</style>